module.exports = __webpack_public_path__ + "static/media/cookie.9275083b.svg";